<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Locais </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn color="info" to="/local/criar" class="ma-2 white--text">
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="locais.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="locais.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :single-expand="singleExpand"
        item-key="descricao"
        :search="search"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.edit="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { downloadLista } from "../../../services/localService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listalocais",
  data() {
    return {
      loading: false,
      singleExpand: true,
      showAtivo: false,
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "N° Local", value: "numeroDoLocal" },
        { text: "Tipo", value: "tipoLocal" },
        { text: "Local", align: "start", value: "descricao" },
        { text: "Contratante", value: "contratante" },
        { text: "Endereço", value: "enderecoCompleto" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "edit", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("local", ["locais"]),
    filteredList() {
      if (this.showAtivo === false) 
      {
        return this.locais.filter((lc) => { return (lc.ativo === true); });
      }
      else
      {
        return this.locais;
      }
    },
  },
  methods: {
    ...mapActions("local", ["atualizarLocais", "atualizarLocal",]),
    editar(local) {
      this.atualizarLocal(local);
      this.$router.push(`/local/editar`);
    },
    baixarlista() {
      downloadLista();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarLocais();
      this.loading = false;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>

